<template>
  <div :class="['club-join', dataReady ? 'loaded' : '']">
    <spinner v-if="showSpinner" />
    <div class="home-page">
      <div v-if="$data.globalData.user" class="home-page-inner">
        <div class="fourth-block-inner game-outer">
          <div class="club-signing">
            <!-- <h1>Ekki í klúbbi</h1> -->
            <h2>{{ pageContent.title }}</h2>
            <p class="sub-text">{{ pageContent.sub_title }}</p>
            <div class="club-search animate-slidein">
              <div class="drop-down">
                <!-- {{newClub.name}} - Golfklúbbur Vatnsleysustrandar -->
                <div class="select desktop-view">
                  <el-select
                    filterable
                    clearable   
                    placeholder="- ég er meðlimur í"
                    class="local-search-dropdown"
                    v-model="clubInfo.name"
                    @change="clickClubName($event)"
                    @clear="clearClubInfo()"
                    :filter-method="getClubInfo">
                    <el-option
                      v-for="item in filteredList"
                      :key="item.key"
                      :label="item.name"
                      :value="item">
                      <span :class="(clubInfo.name == item.name) ? 'show-blue' : ''">{{ item.name }}</span>
                    </el-option>
                  </el-select>
                </div>
                <div class="select mobile-view">
                  <el-select
                    clearable   
                    placeholder="- ég er meðlimur í"
                    class="local-search-dropdown"
                    v-model="clubInfo.name"
                    @change="clickClubName($event)"
                    @clear="clearClubInfo()"
                    :filter-method="getClubInfo">
                    <el-option
                      v-for="item in filteredList"
                      :key="item.key"
                      :label="item.name"
                      :value="item">
                      <span :class="(clubInfo.name == item.name) ? 'show-blue' : ''">{{ item.name }}</span>
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="club-outer" v-if="clubInfo.image_url">
                <div class="club-joined">
                  <div class="club-image">
                    <img v-bind:src="this.clubInfo.image_url" :alt="clubInfo.name"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="proceed-btn" :class="showGreeting?'club-image-joined':''">
      <button
        type="button btn-svara"
        class="button"
        v-if="this.$data.globalData.user"
        v-on:click="joinClub()"
      >
        {{ pageContent.cta_links[0].text }}
      </button>
      <button
        type="button"
        class="button ekki"
        v-if="this.$data.globalData.user"
        v-on:click="proceed('proceedToQuiz')"
      >
        {{ pageContent.cta_links[1].text }}
      </button>
    </div>
  </div>
</template>
<script>
import { ClubInfo, LevelInfo } from '@/shared/dataModels'
import API from '@/shared/api'
export default {
  name: 'ClubJoin',
  data () {
    return {
      clubSearch: [],
      clubInfo: new ClubInfo(),
      clubList: null,
      joinClubInfo: null,
      showJoinClub: true,
      userClub: null,
      dataReady: false,
      userGameInfo: {},
      showGreeting: false,
      currentLevel: new LevelInfo(),
      filteredList: [],
      newClub: new ClubInfo(),
      userClub: null,
      clubImage: null,
      pageContent: {},
      showSpinner: false,
    }
  },
  created () {
    this.getallClubs()
    if (this.$data.globalData.user && this.$data.globalData.user.current_level) {
      this.currentLevel.key = this.$data.globalData.user.current_level.key
      this.currentLevel.name = this.$data.globalData.user.current_level.name
      if (this.$data.globalData.user.user_game_info) {
        this.userGameInfo = this.$data.globalData.user.user_game_info
      }
      this.updateClub(this.$data.globalData.user.user_club)
    }
    if (this.$data.globalData.user) {
      this.userClub = this.$data.globalData.user.user_club
    }
    if (this.$data.globalData.user && this.$data.globalData.user.user_club) {
      this.clubImage = this.$data.globalData.user.user_club.image_url
    }
    if (this.$data.globalData.pageContent) {
      this.pageContent = this.$data.globalData.pageContent['club']
    }
  },
  methods: {
    getClubInfo (searchText) {
      searchText = searchText.toLowerCase()
      const clubList = this.clubSearch
      if  (searchText !== '') {
        this.filteredList = clubList.filter((club) => {
          if (club) {
            if (club.name && club.name.toLowerCase().indexOf(searchText) >= 0) {
              return true
            } else if (club.short_name && club.short_name.toLowerCase().indexOf(searchText) >= 0) {
              return true
            }
          }
          return false
        })
      } else {
        this.filteredList = clubList
      }
    },
    proceed (methodName, value = false) {
      this.$router.push('/spurningar/').then(() => {
        this.$emit(methodName, value)
      })
    },
    getallClubs () {
      let self = this
      API.meInstance.get('/clubs/points/').then((res) => {
        this.clubSearch = res.data.clubs
        this.filteredList = res.data.clubs.sort((a, b) => a.name.localeCompare(b.name))
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    updateClub (clubDetail) {
      if (clubDetail) {
        this.clubInfo = { ...this.clubInfo, ...clubDetail }
      }
    },
    clickClubName (clubDetail) {
      this.updateClub(clubDetail)
    },
    joinClub() {
      this.showSpinner = true
      API.meInstance.get('/join/club/' + this.clubInfo.key + '/').then((res) => {
        if (res.data.status) {
          this.updateClub(res.data.data)
          this.showJoinClub = false
          if (this.$data.globalData && this.$data.globalData.user && !this.$data.globalData.user.user_club) {
            this.$set(this.$data.globalData.user, 'user_club', { 'image_url'  :res.data.data.image_url, 'key': res.data.data.key,'name': res.data.data.name})
          }
          if (this.$data.globalData && this.$data.globalData.user && this.$data.globalData.user.user_club) {
            this.$set(this.$data.globalData.user.user_club, 'image_url', res.data.data.image_url)
            this.$set(this.$data.globalData.user.user_club, 'key', res.data.data.key)
            this.$set(this.$data.globalData.user.user_club, 'name', res.data.data.name)
            this.$set(this.$data.globalData.user.user_club, 'short_name', res.data.data.short_name)
          }
          this.$emit('clubJoined', res.data.data)
          this.dataReady = true
          this.showGreeting = true
          this.showSpinner = false
          this.proceed('clubData', true)
        }
      }).catch((error) => {
        console.log('Error loading', error)
      })
    },
    clearClubInfo() {
      this.clubInfo = new ClubInfo()
    },
  }
}
</script>

<style lang="scss" scoped>
.club-join {
  position: relative;
  .spinner-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.13);
  }
}
.club-signing {
  h1 {
    margin-top: 0;
  }
  .sub-text {
    margin-bottom: 40px;
    @media (max-width: 480px) {
      margin-top: 20px;
    }
  }
}
h2 {
  text-align: center;
}
h1 {
  padding-top: 5rem;
}
.home-page {
  .home-page-inner {
    height: 100%;
  }
}
.fourth-block-inner {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}
.club-search {
  position: relative;
  .drop-down {
    max-width: 315px;
    margin: 0 auto;
  }
}
.plain-text,.proceed-btn  {
  text-align: center;
}
.proceed-btn {
  padding: 25rem 20px 20px;
  .button {
    margin-right: 1.6rem;
    padding: 1.5rem 14rem;
    font-size: 18px;
    &.ekki {
      margin-right: 0;
      padding: 1.3rem 10rem;
      background: #FFFFFF;
      color: #011627;
      border: 2px solid #FCBD00;
    }
  }
  &.club-image-joined {
    padding-top: initial;
  }
}
.club-joined {
  text-align: center;
  .club-image img {
    height: 100px;
    width: 100px;
  }
}
.club-outer {
  padding-top: 7.4rem;
  padding-bottom: 7rem;
  max-width: 435px;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 100;
  opacity: 0;
  height: 250px;
  animation-duration: 3s;
  animation-fill-mode: both;
  animation-name: medal-form-transition;
}
.club-join-text {
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    color: #696865;
    margin: 10px;
}
.sub-text {
  padding: 10px 50px;
}
.row {
  margin-right: 0;
  margin-left: 0;
}
.button {
  border-radius: 10px;
  font-size: 30px;
  &.btn-svara {
    margin-right: 1.6rem !important;
    padding: 1.5rem 14rem !important;
  }
}
  @keyframes medal-form-transition {
  0% {
      opacity: 0;
      transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
@media (max-width: 767px) {
  .proceed-btn {
    padding: 0 20px 20px;
    margin-top: 25rem;
    position: sticky;
    bottom: 0;
    background: #F8F8F8;
  }
  .club-signing {
    h1, h2 {
      text-align: center !important;
    }
    .sub-text {
      text-align: center;
      margin-bottom: 40px;
      margin-top: 20px;
    }
  }
}
@media (max-width: 480px) {
  .club-outer {
    max-width: 100%;
  }
  h1 {
    padding-top: 0;
  }
}
</style>
<style lang="scss">
.el-input--suffix {
  .el-input__inner {  
    background: #FFFFFF;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
    // padding: 30px 65px;
    height: 62px;
    padding-left: 12px;
  }
}
.el-select {
  width: 100% !important;
  .el-input__inner {
    border-radius: 10px;
    border: 1px solid #E5E5E5;
  }
}
.el-select-dropdown__item {
    position: relative;
    font-size: 16px;
    line-height: 22px;
    color: #011627;
    padding: 2.5rem 2rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &.selected {
      color: #011627 !important;
      font-weight: 400 !important;
    }
  &:hover {
    background: #FCBD00;
  }
}
.el-select-dropdown {
  &.el-popper {
    border-radius: 10px;
  }
}
.el-icon-arrow-up{
  &:before {
    color: #FCBD00;
    font-weight: 600;
  }
}
</style>
